import cutomMetadataMutations from "./mutations.js";
import cutomMetadataActions from "./actions.js";
import cutomMetadataGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: cutomMetadataMutations,
  actions: cutomMetadataActions,
  getters: cutomMetadataGetters,
};
